// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import {Trans} from 'react-i18next';
import hopt from 'hola_opt';
import {img_url} from './img_url';
import cn from 'classnames';

interface i_trustpilot_link_props {
    dark?: boolean;
}

export const Trustpilot_link = ({dark}: i_trustpilot_link_props)=>
    <a className="text-item trustpilot"
      target="_blank" rel="noopener noreferrer"
    href="https://www.trustpilot.com/review/hola.org">
    <img src={img_url(`trustpilot/trustpilot${dark ? '_white' : ''}.svg`)}
      alt="Trustpilot" className="lazyload"/>
    <img src={img_url('trustpilot/trustpilot_stars_4_5.svg')}
      className={cn('trustpilot-stars', 'lazyload')} alt="Stars"/>
    <b>{hopt.trustpilot_rating}</b> <Trans>out of</Trans> 5
</a>;
